// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__t24kr","title":"Header_title__obpWM","side":"Header_side__1dp73"};